module.exports = __webpack_public_path__ + "pcph/img/may9.7fba8d97.png";